import xss from 'xss';

const xssFilter = str => {
  const value = str?.replace(/&lt;/g, '<')?.replace(/&gt;/g, '>');
  return xss(value, {
    whiteList: {
      a: ['href', 'target'],
      area: ['shape', 'coords', 'href', 'alt'],
      article: [],
      audio: ['autoplay', 'controls', 'loop', ' muted', 'preload'],
      b: [],
      blockquote: ['cite'],
      br: [],
      caption: [],
      center: [],
      col: ['align', 'valign', 'span', 'width'],
      colgroup: ['align', 'valign', 'span', 'width'],
      del: ['cite', 'datetime'],
      details: ['open'],
      div: [],
      dl: [],
      dt: [],
      em: [],
      embed: ['height', 'src', 'type', 'width'],
      fieldset: ['disabled', 'form', 'name'],
      figcaption: [],
      figure: [],
      footer: [],
      form: ['accept-charset', 'action', 'autocomplete', 'enctype', 'method', 'name', 'novalidate', 'target'],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      header: [],
      hgroup: [],
      hr: [],
      i: [],
      img: ['alt', 'src', 'height', 'width', 'sizes', 'srcset'],
      label: ['for'],
      legend: [],
      li: ['type', 'value'],
      mark: [],
      nav: [],
      ol: ['reversed', 'start', 'type'],
      p: [],
      pre: [],
      section: [],
      small: [],
      span: [],
      strike: [],
      strong: [],
      table: ['summary', 'width'],
      tbody: [],
      td: ['colspan', 'rowspan', 'headers'],
      tfoot: [],
      th: ['colspan', 'rowspan', 'headers'],
      thead: [],
      time: ['datetime'],
      ul: ['type'],
      video: ['autoplay', 'controls', 'loop', ' muted', 'preload', 'src', 'height', 'width'],
    },
    onTag(tag, html) {
      const blacklistTag = ['form', 'input', 'iframe', 'video', 'audio', 'script'];
      if (!blacklistTag.includes(tag)) {
        return html;
      }
      return html?.replace(/(<([^>]+)>)/gi, '');
    },
  });
};

export default xssFilter;
